import { FaLinkedinIn, FaXTwitter, FaGithub, FaInstagram } from "react-icons/fa6";
import { motion } from "framer-motion";
import {
  HiArrowRight,
  HiLocationMarker,
  HiMail,
  HiOutlineSparkles,
  HiPhone,
} from "react-icons/hi";
import BrandLogo from "./BrandLogo";

const socials = [
  { icon: FaLinkedinIn, href: "https://www.linkedin.com/company/beeverge/", label: "LinkedIn" },
  { icon: FaXTwitter, href: "#", label: "X" },
  { icon: FaGithub, href: "#", label: "GitHub" },
  { icon: FaInstagram, href: "#", label: "Instagram" },
];

const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Product", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Career", href: "#career" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

const footerServices = [
  "Custom Software",
  "Web Applications",
  "Mobile Apps",
  "UI/UX Design",
];

function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-cyan-200/10 bg-black/40">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-300/60 to-transparent" />
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-cyan-300/10 blur-3xl" />

      <div className="section-shell py-12 sm:py-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="grid gap-8 lg:grid-cols-[1.25fr_0.7fr_0.8fr_1fr]"
        >
          <div>
            <BrandLogo size="footer" />

            <p className="mt-5 max-w-sm text-sm leading-7 text-blue-100/72">
              BeeVerge is a future-ready IT company building secure web apps, mobile apps,
              automation systems, and digital products for growing businesses.
            </p>

            <div className="mt-6 flex items-center gap-3">
              {socials.map(({ icon: Icon, href, label }) => (
                <motion.a
                  key={label}
                  href={href}
                  aria-label={label}
                  whileHover={{ y: -3, scale: 1.08 }}
                  whileTap={{ scale: 0.95 }}
                  className="glass inline-flex h-10 w-10 items-center justify-center rounded-lg text-cyan-200 transition hover:shadow-neon"
                >
                  <Icon className="h-4 w-4" />
                </motion.a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-cyan-300">
              Quick Links
            </h3>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-blue-100/75 transition hover:text-cyan-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-cyan-300">
              Services
            </h3>
            <ul className="mt-5 space-y-3">
              {footerServices.map((service) => (
                <li key={service} className="flex items-center gap-2 text-sm text-blue-100/75">
                  <HiOutlineSparkles className="h-4 w-4 text-cyan-300" />
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="glass rounded-2xl p-5 shadow-glass">
            <h3 className="text-lg font-semibold text-white">Ready to build something?</h3>
            <p className="mt-3 text-sm leading-6 text-blue-100/72">
              Tell us about your idea and BeeVerge will help shape it into a clear, launch-ready
              product plan.
            </p>

            <div className="mt-5 space-y-3 text-sm text-blue-100/78">
              <p className="flex items-center gap-3 break-all">
                <HiMail className="h-5 w-5 text-cyan-300" />
                beeverge27@gmail.com
              </p>
              <p className="flex items-center gap-3">
                <HiPhone className="h-5 w-5 text-cyan-300" />
                +91 897******3
              </p>
              <p className="flex items-start gap-3">
                <HiLocationMarker className="h-5 w-5 text-cyan-300" />
                India, serving clients worldwide
              </p>
            </div>

            <motion.a
              href="#contact"
              whileHover={{ scale: 1.03, x: 4 }}
              whileTap={{ scale: 0.98 }}
              className="mt-6 inline-flex items-center gap-3 rounded-lg border border-cyan-200/30 bg-cyan-300/10 px-4 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-cyan-100 transition hover:shadow-neon sm:px-5 sm:text-sm sm:tracking-[0.14em]"
            >
              Contact Us
              <HiArrowRight className="h-5 w-5" />
            </motion.a>
          </div>
        </motion.div>

        <div className="mt-10 flex flex-col justify-between gap-4 border-t border-white/10 pt-6 text-sm text-blue-100/60 sm:flex-row sm:items-center">
          <p>&copy; {new Date().getFullYear()} BeeVerge. Future-Ready IT Engineering.</p>
          <div className="flex flex-wrap gap-4">
            <a href="#home" className="transition hover:text-cyan-300">
              Privacy Policy
            </a>
            <a href="#home" className="transition hover:text-cyan-300">
              Terms
            </a>
            <a href="#contact" className="transition hover:text-cyan-300">
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
